import React from 'react';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

const OT_RATES = [
  { value: 1.0, label: 'x1.0 — OT อัตราปกติ' },
  { value: 1.5, label: 'x1.5 — วันทำงานปกติ' },
  { value: 2.0, label: 'x2.0 — OT ต่อจากวันหยุด' },
  { value: 3.0, label: 'x3.0 — วันหยุด / นักขัตฤกษ์' },
];

const OT_STATUS = {
  APPROVE: { label: 'อนุมัติแล้ว', bg: '#dcfce7', color: '#166534' },
  PENDING: { label: 'รออนุมัติ', bg: '#fef3c7', color: '#92400e' },
  REJECT: { label: 'ไม่อนุมัติ', bg: '#fee2e2', color: '#991b1b' },
};

const OV = { position: 'fixed', inset: 0, zIndex: 1300, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center' };
const MO = { background: '#fff', borderRadius: 8, maxWidth: 380, width: 'calc(100% - 32px)', maxHeight: '90vh', overflowY: 'auto' };
const MH = { padding: '14px 20px', borderBottom: '1px solid #e5e7eb' };
const MB = { padding: '16px 20px' };
const MF = { padding: '12px 20px', borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' };
const IS = { width: '100%', boxSizing: 'border-box', padding: '6px 10px', borderRadius: 4, border: '1px solid #d1d5db', fontSize: '0.875rem', outline: 'none' };
const BC = { padding: '6px 14px', borderRadius: 4, border: '1px solid #d1d5db', backgroundColor: '#fff', color: '#374151', cursor: 'pointer', fontSize: '0.875rem' };
const BE = { padding: '6px 12px', borderRadius: 4, border: 'none', backgroundColor: 'transparent', color: '#d32f2f', cursor: 'pointer', fontSize: '0.875rem' };

const Row = ({ label, children }) => (
  <div style={{ marginBottom: 12 }}>
    <label style={{ display: 'block', fontSize: '0.75rem', color: '#666', marginBottom: 3, fontWeight: 500 }}>{label}</label>
    {children}
  </div>
);

const AddOtDialog = React.memo(function AddOtDialog({
  open, onClose, addOtTarget, month, year,
  addOtRate, setAddOtRate, addOtHours, setAddOtHours,
  otDlgAutoAmt, otDlgEx, otDlgHasEx, addOtSaving, saveAddOt, clearManualOt,
}) {
  if (!open) return null;
  return (
    <div style={OV} onClick={onClose}>
      <div style={MO} onClick={(e) => e.stopPropagation()}>
        <div style={MH}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
            <AddCircleOutlineIcon style={{ fontSize: 18, color: '#ea580c' }} />
            <span style={{ fontWeight: 600, fontSize: '1rem' }}>เพิ่ม / แก้ไข OT</span>
          </div>
          {addOtTarget?.empName && <div style={{ fontSize: '0.875rem', color: '#6b7280' }}>{addOtTarget.empName}</div>}
          <div style={{ fontSize: '0.75rem', color: '#9ca3af' }}>วันที่ {addOtTarget?.day}/{month + 1}/{year}</div>
          {addOtTarget?.otStatus && (() => {
            const s = OT_STATUS[addOtTarget.otStatus] || { label: addOtTarget.otStatus, bg: '#f3f4f6', color: '#4b5563' };
            return (
              <div style={{ marginTop: 6 }}>
                <span style={{ padding: '2px 10px', borderRadius: 12, background: s.bg, color: s.color, fontSize: '0.7rem', fontWeight: 700 }}>
                  สถานะคำขอ OT: {s.label}
                </span>
                {addOtTarget.otStatus !== 'APPROVE' && (
                  <span style={{ marginLeft: 6, fontSize: '0.7rem', color: '#9ca3af' }}>ชม.ที่แสดงเป็นของคำขอ ยังไม่ถูกนำไปคำนวณ</span>
                )}
              </div>
            );
          })()}
          {(addOtTarget?.projectNumber || addOtTarget?.projectName) && (
            <div style={{ fontSize: '0.75rem', color: '#0369a1', marginTop: 2 }}>
              โครงการ: {addOtTarget?.projectNumber}
              {addOtTarget?.projectNumber && addOtTarget?.projectName ? ' — ' : ''}
              {addOtTarget?.projectName}
            </div>
          )}
        </div>

        <div style={MB}>
          <Row label="OT Rate">
            <select value={addOtRate} style={{ ...IS, cursor: 'pointer' }} onChange={(e) => setAddOtRate(Number(e.target.value))}>
              {OT_RATES.map((r) => <option key={r.value} value={r.value}>{r.label}</option>)}
            </select>
          </Row>

          <Row label="จำนวนชั่วโมง OT (ชม.)">
            <input type="number" value={addOtHours} style={IS} min={0} max={24} step={0.5}
              onChange={(e) => setAddOtHours(e.target.value)} />
          </Row>

          <div style={{ backgroundColor: '#fff7ed', border: '1px solid #fed7aa', borderRadius: 4, padding: '10px 14px' }}>
            <div style={{ fontSize: '0.75rem', color: '#6b7280', marginBottom: 2 }}>ค่า OT (x{addOtRate})</div>
            <div style={{ color: '#ea580c', fontWeight: 700, fontSize: '1.1rem' }}>
              ฿{(otDlgAutoAmt ?? 0).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </div>
          </div>

          {otDlgEx?.edited_by && (
            <div style={{ fontSize: '0.75rem', color: '#6b7280', marginTop: 10 }}>บันทึกโดย: {otDlgEx.edited_by}</div>
          )}
        </div>

        <div style={MF}>
          <div>{otDlgHasEx && <button style={BE} onClick={clearManualOt} disabled={addOtSaving}>ลบ OT</button>}</div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button style={BC} onClick={onClose} disabled={addOtSaving}>ยกเลิก</button>
            <button
              style={{ padding: '6px 16px', borderRadius: 4, border: 'none', backgroundColor: '#ea580c', color: '#fff', cursor: 'pointer', fontSize: '0.875rem', fontWeight: 500, opacity: addOtSaving || !addOtHours ? 0.6 : 1 }}
              onClick={saveAddOt} disabled={addOtSaving || !addOtHours}
            >
              {addOtSaving ? 'กำลังบันทึก...' : 'บันทึก'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
});

export default AddOtDialog;
